import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'

const FonctionContext = createContext();

export const FonctionProvider = ({ children }) => {
    
    // You can have a single state object for user attributes
    const [fonctions, setFonctions] = useState({});
   
    const setFonctionAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setFonctions((prevFonction) => ({ ...prevFonction, ...attributes }));
  
    };
    // Utilisation de useMemo pour mémoïser l'objet `value`
    const value = useMemo(() => ({
      fonctions,
      setFonctionAttributes
  }), [fonctions]);

  
    return (
      <FonctionContext.Provider value={value}>
        {children}
      </FonctionContext.Provider>
    );
  };
  FonctionProvider.propTypes={
    children:PropTypes.node.isRequired
  }
  
  export const useFonction = () => {
    return useContext(FonctionContext);
  };